export default "__VITE_ASSET__0de2bc49__"